/**
 * Hook: Dock position — bottom/top/left/right
 * Persisted in localStorage
 */
import { useState } from 'react'

export type DockPosition = 'bottom' | 'top' | 'left' | 'right'

export function useDockPosition() {
  const [position, setPosition] = useState<DockPosition>(() => {
    return (localStorage.getItem('dock-position') as DockPosition) ?? 'bottom'
  })

  const setPos = (pos: DockPosition) => {
    localStorage.setItem('dock-position', pos)
    setPosition(pos)
  }

  const isHorizontal = position === 'bottom' || position === 'top'

  return { position, setPos, isHorizontal }
}
